var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-i"},[_c('div',{staticClass:"content-box"},[_c('matches',{attrs:{"filter":_vm.$route.query}})],1),_vm._v(" "),_c('div',{staticClass:"content-panel compact"},[_c('div',{staticClass:"content-panel-close",on:{"click":function($event){_vm.controlPanel()}}},[_c('i',{staticClass:"os-icon os-icon-close"})]),_vm._v(" "),_c('sports')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1b98d80","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/fixture.vue
// module id = jTAH
// module chunks = 0